import Delivery from '../src/Delivery/index.tsx';
export default Delivery;
